export default __webpack_public_path__ + "static/four-0f20c6d797dc17fdcf8eaf9b5eb01311.jpg";